import { render, staticRenderFns } from "./adminLottery.vue?vue&type=template&id=95c6b60a&scoped=true&"
import script from "./adminLottery.vue?vue&type=script&lang=js&"
export * from "./adminLottery.vue?vue&type=script&lang=js&"
import style0 from "./adminLottery.vue?vue&type=style&index=0&id=95c6b60a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95c6b60a",
  null
  
)

export default component.exports